module.exports = __webpack_public_path__ + "static/media/lets-meditate.b53314ad.svg";